import { LinkBase, Text, Image } from '@belong/ui';
import clsx from 'clsx';
import { kebabCase } from 'es-toolkit/compat';
import styles from './local-services.module.css';
import { LocalServicesProps, LocalService } from './local-services.types';

export function LocalServices({
  address,
  hasCityLpCard,
  hasNeighborhoodLpCard,
}: LocalServicesProps): JSX.Element {
  const { city, neighborhood, state } = address;

  const formattedCity = kebabCase(city ?? '');
  const formattedNeighborhood = kebabCase(neighborhood ?? '');
  // `!`: the slug was already built from `state` unconditionally.
  const formattedCitySlug = `${formattedCity}-${state!.toLowerCase()}-property-management`;

  const localServices: LocalService[] = [];

  if (hasNeighborhoodLpCard) {
    localServices.push({
      cardTitle: 'Neighborhood',
      src: 'https://belong-web-assets.s3.us-west-2.amazonaws.com/neighborhood-draw-v2.svg',
      description: neighborhood ?? '',
      link: `/homeowners/${formattedCitySlug}/${formattedNeighborhood}`,
    });
  }

  if (hasCityLpCard) {
    localServices.push({
      cardTitle: 'City',
      src: 'https://belong-web-assets.s3.us-west-2.amazonaws.com/building-draw.svg',
      description: city ?? '',
      link: `/homeowners/${formattedCitySlug}`,
    });
  }

  return (
    <div className="mb-xl mt-3xl">
      <Text as="h3" variant="h3" className="mb-sm font-semibold">
        More About This Location
      </Text>

      <div className="gap-x-lg grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {localServices.map((el) => {
          return (
            <LinkBase
              href={el.link}
              key={el.cardTitle}
              className={clsx(
                'mb-xs border-gray bg-light-gray p-sm hover:border-navy w-full rounded border border-solid lg:mb-0',
                styles.card,
              )}
            >
              <div className="flex items-center">
                <Image
                  src={el.src}
                  alt=""
                  className="w-full"
                  style={{ maxWidth: 100 }}
                />
                <div className="ml-sm">
                  <Text fontWeight="semibold" className="mb-2xs">
                    {el.description}
                  </Text>
                  <Text>{el.cardTitle}</Text>
                </div>
              </div>
            </LinkBase>
          );
        })}
      </div>
    </div>
  );
}
